export default "__VITE_ASSET__DPAod89O__"